/**
 * API de Estatísticas Diárias
 */

import api from './api';

export const estatisticasDiariasApi = {
  // Obter estatísticas
  getStats: (params) => api.get('/estatisticas-diarias', { params }),

  // Obter totais agregados
  getTotais: (params) => api.get('/estatisticas-diarias/totais', { params }),

  // Obter estatísticas agrupadas (dia ou semana)
  getAgrupadas: (params) => api.get('/estatisticas-diarias/agrupadas', { params }),

  // Obter lista de entidades
  getEntidades: () => api.get('/estatisticas-diarias/entidades'),

  // Calcular estatísticas (admin)
  calcular: (data) => api.post('/estatisticas-diarias/calcular', data)
};

export default estatisticasDiariasApi;
